import {
    ALL_USER_ATTENDENCE,
    FETCH_ERROR,
    GET_ATTENDENCE,
    GET_PRESENT_ATTENDENCE_COUNT,
    USER_FILTER_ATTENDENCE,
    USER_UNDER_MANAGER,
    GET_ALL_DEVICE_NAME_ATTENDENCE,
} from "shared/constants/ActionTypes";

const initialState = {
    error: null,
    userAttendenceList: [],
    allUserAttendenceList: [],
    filterUserAttendenceList: [],
    userUnderManagerList: [],
    userPresentCount: {},
    allDeviceList: {},
};
export const attendenceReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ERROR:
            return { ...state, error: payload };
        case GET_ATTENDENCE:
            return {
                ...state,
                userAttendenceList: payload,
            };
        case ALL_USER_ATTENDENCE:
            return { ...state, allUserAttendenceList: payload };
        case USER_FILTER_ATTENDENCE:
            return { ...state, userAttendenceList: payload };
        case GET_PRESENT_ATTENDENCE_COUNT:
            return { ...state, userPresentCount: payload };
        case USER_UNDER_MANAGER:
            return { ...state, userUnderManagerList: payload };
        case GET_ALL_DEVICE_NAME_ATTENDENCE:
            return { ...state, allDeviceList: payload };
        default:
            return state;
    }
};
